import { Component } from '@angular/core';

@Component({
  selector: 'fl-modal-actions',
  template: `
    <div>- - - - - - - - - some dashed line - - - - - - - - - - or whatever - - - - -</div>
    <div>ACTIONS</div>
    <div><ng-content></ng-content></div>
    <div>- - - - - - - - - some dashed line - - - - - - - - - - or whatever - - - - -</div>
  `,
  styleUrls: ['./modal-actions.component.scss'],
})
export class ModalActionsComponent {}



// WEBPACK FOOTER //
// /mnt/jenkins-slave-workspace/workspace/gaf-build-i18n-webapp-compat/LANG/zh/webapp/src/app/@shared/ui/modal/modal-actions.component.ts